module.exports = __webpack_public_path__ + "static/media/SidPrakash@3x.db8712d9.png";